<template>
  <div class="header">
    <div id="user_info">

      <div class="bgjd">
        <p>智医-报告解读</p>
      </div>

      <el-dropdown>
        <span class="el-dropdown-link">
            <span>
              <img style="cursor: pointer;" :src="require('@/images/微信图片_20241202113518.png')">
            </span>
            <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span style="width: 100%;height: 100%;" @click="$router.push('/beckman/ARR/wizard/info')">个人中心</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span style="width: 100%;height: 100%;" @click="logout">退出登录</span>
            <!--<a href="/login" style="text-decoration: none;color: #606266;">退出登录</a>-->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
  </div>
</template>

<script>

import {logout} from "@/api";
import {clear_cookie} from "@/utils";

export default {
  name: "AppHeader",
  methods: {
    logout() {
      logout().then((res => {
        clear_cookie()
        open('/login', '_self')
      }))
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: 56px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  background: #e8ebf7;
  box-shadow: 0 1px 2px rgb(0 0 0 / 14%);

  #user_info {
    display: flex;
    align-items: center;
    height: 100%;

    & > div {
      display: flex;
      align-items: center;
    }

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
}

.bgjd {
  position: absolute;
  left: 0;
  padding-left: 27px;
  font-size: 20px;
  font-weight: 600;
}
</style>

